// Legacy exports (JSON logger utilities)
export { enableJsonLogger } from '@maestro/core/logger/logger'

// Main exports from unified logger
export {
  type ClientLogger,
  createClientLogger,
  createLogger,
  type Logger,
  type LogLevel,
  type NamespacedLogger,
} from '@maestro/core/logger/unified-logger'
